import React, { useEffect, useState } from "react"
import {
  Button,
  CircularProgress,
  Grid,
  ButtonGroup,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper
} from "@mui/material"
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"
import { pdf } from "@react-pdf/renderer"
import AutocompleteDeluxe from "../../components/AutocompleteDelux"
import Vista from "../../components/Vista"
import { productDetails } from "../../utils/styles"
import { NavLink } from "react-router-dom/cjs/react-router-dom.min"
import { useLocalStorage } from "../../hooks/useLocalStorage"
import Servo from "../../services/servo"
import { isJac } from "../../utils/moduleAccess"
import pdfOrdenServicio from "../../pdfs/pdfOrdenServicio"
import pdfOrdenCompra from "../../pdfs/pdfOrdenCompra"

const ReporteAvance = () => {
  const [permiso] = useLocalStorage("permiso", null)
  const [loading, setLoading] = useState(false)
  const [carro, setCarro] = useState(null)
  const [ordenesServicio, setOrdenesServicio] = useState([])

  const getTodasLasOrdenes = async () => {
    setLoading(true)

    const expands =
      "&expand=checklists.datoschecklists.areas," +
      "checklists.datoschecklists.carros," +
      "checklists.gasolinachecklists.notas," +
      "empresas," +
      "observaciones," +
      "manosObraOrdenServicio.manosObra," +
      "refacciones.productos," +
      "diagnosticos.productos.lote," +
      "otroTaller.archivos," +
      "ordenesCompra.ordenesCompraRefacciones.productos," +
      "ordenesCompra.ordenesCompraRefacciones.proveedores," +
      "inspecciones," +
      "creados"

    try {
      let res = await Servo.get(`orden-servicios/unidades?${expands}`)

      let resultado =
        res?.cuerpo?.resultado && Array.isArray(res.cuerpo.resultado)
          ? res.cuerpo.resultado
          : []

      // 🔥 Si el usuario tiene rol JAC → filtrar solo unidades marca JAC
      if (isJac(permiso)) {
        resultado = resultado.filter((orden) => {
          const marca =
            orden?.checklists?.datoschecklists?.carros?.marca?.trim().toLowerCase()
          return marca === "jac"
        })
      }

      setOrdenesServicio(resultado)
    } catch (error) {
      console.error("Error al obtener todas las órdenes:", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getTodasLasOrdenes()
  }, [])

  const getOrdenesPorUnidad = async (idCarro) => {
    if (!idCarro) {
      // Si se borra el autocomplete → recargar TODAS las órdenes
      getTodasLasOrdenes()
      return
    }

    setLoading(true)

    const expands =
      "&expand=checklists.datoschecklists.areas," +
      "checklists.datoschecklists.carros," +
      "checklists.gasolinachecklists.notas," +
      "empresas," +
      "observaciones," +
      "manosObraOrdenServicio.manosObra," +
      "refacciones.productos," +
      "diagnosticos.productos.lote," +
      "otroTaller.archivos," +
      "ordenesCompra.ordenesCompraRefacciones.productos," +
      "ordenesCompra.ordenesCompraRefacciones.proveedores," +
      "inspecciones," +
      "creados"

    try {
      let res = await Servo.get(
        `orden-servicios/por-unidad?idCarro=${idCarro}${expands}`
      )

      if (res && res.cuerpo && Array.isArray(res.cuerpo.resultado)) {
        setOrdenesServicio(res.cuerpo.resultado)
      } else {
        setOrdenesServicio([])
      }
    } catch (error) {
      console.error("Error al obtener órdenes por unidad:", error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Vista>
      <div className={productDetails.screenSize}>
        {/* <div className={productDetails.volverProductos}>
          {(permiso[permisoCheck] & 1) === 1 ? (
            <NavLink exact to={"/home"}>
              « Volver al inicio
            </NavLink>
          ) : (
            <p>« Volver al inicio</p>
          )}
        </div> */}
        <div className={productDetails.formArea}>
          <Grid
            container
            spacing={2}
            sx={{ p: 2, display: "flex", flexDirection: "column" }}
          >
            <Grid item>
              <h2>Reporte Ordenes de servicio por unidad</h2>
              <AutocompleteDeluxe
                labelToShow="Unidad"
                labelProp="vin"
                nombre="carros"
                value={carro}
                setDato={setCarro}
                background={"#FFFFFF"}
                placeholder="Seleccione una unidad"
                filterOptions={(options) => {
                  if (!isJac(permiso)) return options

                  return options.filter(
                    (car) => car.marca?.trim().toLowerCase() === "jac"
                  )
                }}
                onChange={(e, value) => {
                  const idCarro = value ? value.idCarro : 0
                  setCarro(value)
                  getOrdenesPorUnidad(idCarro)
                }}
              />
            </Grid>
            {ordenesServicio.length > 0 && (
              <Grid container spacing={2} style={{ marginTop: "20px" }}>
                <Grid item xs={12}>
                  <h3>Órdenes de Servicio para la Unidad: {carro?.vin}</h3>
                  <TableContainer component={Paper}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Folio</TableCell>
                          <TableCell>Fecha de Entrada</TableCell>
                          <TableCell>VIN</TableCell>
                          <TableCell>Placas</TableCell>
                          <TableCell>No. Económico</TableCell>
                          <TableCell>Año</TableCell>
                          <TableCell>Marca</TableCell>
                          <TableCell>Odómetro(Km)</TableCell>
                          <TableCell>Orden Trabajo</TableCell>
                          <TableCell>Factura</TableCell>
                          <TableCell>OC</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {ordenesServicio.map((orden) => (
                          <TableRow key={orden.idOrdenServicio}>
                            <TableCell>{orden.idOrdenServicio}</TableCell>
                            <TableCell>{orden.creado}</TableCell>

                            <TableCell>
                              {orden.checklists?.datoschecklists?.carros?.vin ||
                                "N/A"}
                            </TableCell>
                            <TableCell>
                              {orden.checklists?.datoschecklists?.carros
                                ?.placas || "N/A"}
                            </TableCell>
                            <TableCell>
                              {orden.checklists?.datoschecklists?.carros
                                ?.economico || "N/A"}
                            </TableCell>
                            <TableCell>
                              {orden.checklists?.datoschecklists?.carros
                                ?.year || "N/A"}
                            </TableCell>
                            <TableCell>
                              {orden.checklists?.datoschecklists?.carros
                                ?.marca || "N/A"}
                            </TableCell>
                            <TableCell>
                              {orden.checklists?.gasolinachecklists
                                ?.kilometraje + " Km" || "N/A"}
                            </TableCell>

                            <TableCell>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  width: "100%",
                                  height: "100%"
                                }}
                              >
                                <PictureAsPdfIcon
                                  style={{
                                    color: "#157CC1",
                                    cursor: "pointer"
                                  }}
                                  onClick={async (e) => {
                                    e.stopPropagation()
                                    e.preventDefault()
                                    try {
                                      let pdfBlob = await pdfOrdenServicio(
                                        orden
                                      )
                                      window.open(
                                        window.URL.createObjectURL(pdfBlob),
                                        "_blank"
                                      )
                                    } catch (error) {
                                      console.error(
                                        "Error al generar el PDF:",
                                        error
                                      )
                                    }
                                  }}
                                ></PictureAsPdfIcon>
                              </div>
                            </TableCell>

                            <TableCell>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  gap: "10px",
                                  width: "100%",
                                  height: "100%"
                                }}
                              >
                                {(() => {
                                  const archivos = Array.isArray(
                                    orden?.otroTaller
                                  )
                                    ? orden.otroTaller.flatMap(
                                        (x) => x.archivos || []
                                      )
                                    : []
                                  const tieneFacturas = archivos.length > 0

                                  return (
                                    <PictureAsPdfIcon
                                      style={{
                                        color: tieneFacturas ? "red" : "gray",
                                        cursor: tieneFacturas
                                          ? "pointer"
                                          : "not-allowed",
                                        opacity: tieneFacturas ? 1 : 0.4
                                      }}
                                      titleAccess={
                                        tieneFacturas
                                          ? "Abrir facturas adjuntas"
                                          : "Esta orden no tiene facturas"
                                      }
                                      onClick={(e) => {
                                        if (!tieneFacturas) return
                                        e.stopPropagation()
                                        e.preventDefault()

                                        archivos.forEach((archivo) => {
                                          if (archivo.url)
                                            window.open(archivo.url, "_blank")
                                        })
                                      }}
                                    />
                                  )
                                })()}
                              </div>
                            </TableCell>

                            <TableCell>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  gap: "10px",
                                  width: "100%",
                                  height: "100%"
                                }}
                              >
                                {(() => {
                                  const ordenesCompra = Array.isArray(
                                    orden?.ordenesCompra
                                  )
                                    ? orden.ordenesCompra
                                    : []

                                  const tieneOC = ordenesCompra.length > 0

                                  return (
                                    <PictureAsPdfIcon
                                      style={{
                                        color: tieneOC ? "#157CC1" : "gray",
                                        cursor: tieneOC
                                          ? "pointer"
                                          : "not-allowed",
                                        opacity: tieneOC ? 1 : 0.4
                                      }}
                                      titleAccess={
                                        tieneOC
                                          ? "Descargar órdenes de compra"
                                          : "No hay órdenes de compra registradas"
                                      }
                                      onClick={async (e) => {
                                        if (!tieneOC) return

                                        e.stopPropagation()
                                        e.preventDefault()

                                        try {
                                          // 🔥 Generar un PDF por cada Orden de Compra
                                          for (const oc of ordenesCompra) {
                                            const blob = await pdfOrdenCompra(
                                              oc
                                            )
                                            const url =
                                              window.URL.createObjectURL(blob)
                                            window.open(url, "_blank")
                                          }
                                        } catch (err) {
                                          console.error(
                                            "Error generando OC PDFs:",
                                            err
                                          )
                                        }
                                      }}
                                    />
                                  )
                                })()}
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>
            )}
          </Grid>
        </div>
      </div>
    </Vista>
  )
}

export default ReporteAvance
